<script>
    import { getContext } from 'svelte';
    import { fly } from 'svelte/transition';
    import { height as windowHeight, landscape } from '../../stores/bounds';
    import SveltePerfectScrollbar from '../../components/SveltePerfectScrollbar/SveltePerfectScrollbar.svelte'

    export let title = ''

    const isMobile = getContext('mobileDevice')
</script>

<style>
    .Editor.basic-panel-content {
        width: 960px;
        height: 400px;
        padding: 0;
        position: relative;
        z-index: 2;
    }
    .Editor.basic-panel-content.mobile {
        width: 100%;
        height: 100%;
    }

    .Editor .content {
        position: relative;
        width: calc(100% - 260px);
        height: 100%;
        overflow: auto;
    }
    .Editor .heading {
        font-size: 20px;
        color: #465d6f;
        padding: 10px 20px;
        text-transform: capitalize;
    }
    .Editor .form {
        padding: 20px;
    }
    
    .Editor .list {
        position: absolute;
        width: 260px;
        height: 100%;
        top: 0;
        right: 0;
        border-left: 1px dashed #bacad1;
        background-color: #ecf2f6;
        overflow: hidden;
    }
    .ctrls {
        margin-top: 10px;
        text-align: left;
        position: relative;
        z-index: 1;
    }
    .ctrls.mobile {
        position: absolute;
        width: calc(100% - 260px);
        margin-top: 0;
        bottom: 0;
        padding: 20px 20px 10px 20px;
        background-color: #fff;
        z-index: 2;
    }
    .ctrls :global(button) {
        padding: .40rem 1.3rem;
    }
    .ctrls :global(.btn) {
        margin-right: 5px;
    }

    .landscape-alert {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 40;
        background-color: #fff;
    }
    .landscape-alert .alert-msg {
        position: absolute;
        width: 100%;
        top: 50%;
        left: 0;
        text-align: center;
        transform: translateY(-50%);
    }
    .landscape-alert .icon {
        font-size: 70px;
        transform: rotate(90deg);
    }
    .landscape-alert .text {
        font-size: 18px;
    }
</style>

<div class="Editor basic-panel-content" class:mobile={isMobile}>
    <div class="content">
        <div class="heading">{title}</div>
        <SveltePerfectScrollbar height={isMobile ? ($windowHeight - 100) : 350}>
            <div class="form">
                <slot />
            </div>
            {#if isMobile}
                <div style="height: 70px"></div>
            {/if}
        </SveltePerfectScrollbar>
    </div>
    <div class="list">
        <slot name="list"/>
    </div>
</div>
<div class="ctrls" class:mobile={isMobile} in:fly={{ y: isMobile ? 60 : -60, duration: 300, delay: 300 }}>
    <slot name="buttons"/>
</div>
{#if isMobile && $landscape === false}
    <div class="landscape-alert">
        <div class="alert-msg">
            <div class="icon">
                <i class="far fa-mobile"></i>
            </div>
            <div class="text">
                Gira il device in orizzontale
            </div>
        </div>
    </div>
{/if}